export const UPDATE_COMPETENCY_CATEGORIES = 'UPDATE_COMPETENCY_CATEGORIES';

export const updateCompetencyCategories = (payload) => {
    return {
        type: UPDATE_COMPETENCY_CATEGORIES,
        payload,
    };
};
